import { useState } from 'react';
import { Button, Heading, Popup, PopupSection, Text } from '@flixbus/honeycomb-react';
import { Icon, IconWarning } from '@flixbus/honeycomb-icons-react';
import { confirmPiiWarning } from '../../services/searchService';
import { useErrorNotification } from '../../hooks/useErrorNotification';
import { ERRORS } from '../../constants/messages';

const CONFIRMATION_KEY = 'warningTime';
const ASK_AGAIN_AFTER_DAYS = 7;

const isConfirmationDue = () => {
    const confirmedAt = localStorage.getItem(CONFIRMATION_KEY);
    if (!confirmedAt) return true;
    const days = (Date.now() - new Date(confirmedAt).getTime()) / (1000 * 3600 * 24);
    return days >= ASK_AGAIN_AFTER_DAYS;
};

// The exported files contain personal data; users confirm the handling rules once a week.
const WarningPage = () => {
    const notifyError = useErrorNotification();
    const [open, setOpen] = useState(isConfirmationDue);

    const confirm = async () => {
        localStorage.setItem(CONFIRMATION_KEY, new Date().toISOString());
        try {
            await confirmPiiWarning();
        } catch (error) {
            notifyError(error, ERRORS.confirmPii);
        }
        setOpen(false);
    };

    return (
        <Popup id="pii-popup" aria-labelledby="pii-popup-title" active={open}>
            <PopupSection type="icon">
                <Icon InlineIcon={IconWarning} size={12} extraClasses="pii-warning-icon" aria-hidden="true" />
            </PopupSection>
            <PopupSection type="title">
                <Heading id="pii-popup-title" size={2} sectionHeader flushSpace>
                    Personally Identifiable Information
                </Heading>
            </PopupSection>
            <PopupSection type="content">
                <Text>
                    Extraction files created through this product include <b>sensitive personal information (PII)</b>.
                </Text>
                <Text>To protect data privacy:</Text>
                <Text>
                    <b>*</b> Always delete these files after use
                </Text>
                <Text>
                    <b>**</b> Regularly empty your recycle bin to permanently remove them
                </Text>
            </PopupSection>
            <PopupSection type="actions" extraClasses="pii-popup__actions">
                <Button extraClasses="hcr-space-2-top" appearance="primary" onClick={confirm}>
                    I understand and will comply
                </Button>
            </PopupSection>
        </Popup>
    );
};

export default WarningPage;
